import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class Formatters {
    buildStepsFromExplanation(explanation: string) {
        if (!explanation) return [];

        let parsed: any;

        // Step 1 — Safe JSON parsing
        try {
            parsed = JSON.parse(explanation);
        } catch (e) {
            // fallback: try to extract JSON from messy string
            try {
                const start = explanation.indexOf('{');
                const end = explanation.lastIndexOf('}') + 1;
                const clean = explanation.slice(start, end);
                parsed = JSON.parse(clean);
            } catch (err) {
                alert("If you see this alert, please contact as on: hafid.dahhani@fusionlex.com");
                console.log("Failed to parse LLM JSON", err);
                return [];
            }
        }

        // Step 2 — Validate structure
        if (!parsed?.steps || !Array.isArray(parsed.steps)) {
            alert("If you see this alert, please contact as on: hafid.dahhani@fusionlex.com");
            console.warn("⚠️ Invalid LLM format:", parsed);
            return [];
        }

        // Step 3 — Normalize output
        const steps = parsed.steps.map((step: any, index: number) => ({
            step: index + 1,
            title: step.title ?? "Untitled",
            explanation: step.explanation ?? "",
            created_at: new Date()
        }));

        // Step 4 — Return structured object
        return {
            steps: steps,
            moments: {
                interaction_transition: parsed.interaction_transition ?? null,
                local_pattern: parsed.local_pattern ?? null,
                // interactionType: parsed.interaction_type ?? null,
                // behavioralStance: parsed.behavioral_stance ?? null
            }
        };
    }

    formatTime(t: number): string {
        if (!t && t !== 0) return '00:00';

        const hours = Math.floor(t / 3600);
        const minutes = Math.floor((t % 3600) / 60);
        const seconds = Math.floor(t % 60);

        if (hours > 0) {
            return `${hours.toString().padStart(2, '0')}:` +
                `${minutes.toString().padStart(2, '0')}:` +
                `${seconds.toString().padStart(2, '0')}`;
        }

        return `${minutes.toString().padStart(2, '0')}:` +
            `${seconds.toString().padStart(2, '0')}`;
    }

    prettyLabel(key: string): string {
        return key
            .replace(/_/g, ' ')
            .replace(/\b\w/g, l => l.toUpperCase());
    }

    truncateConversationTitle(title: string, maxLength: number = 20): string {
        if (!title) return '';

        return title.length > maxLength
            ? title.substring(0, maxLength) + '...'
            : title;
    }
}